module.exports = __webpack_public_path__ + "img/1940-LDF.f85c90e7.jpg";